module.exports = __webpack_public_path__ + "img/mode_comment.8891587a.svg";